export const PUNCHOUT_USER_STORAGE_KEY = 'punchout_user';

export const PUNCHOUT_JWT_BUYER_COOKIE_KEY = 'punchout_buyer_cookie';
export const PUNCHOUT_JWT_RETURN_URL_KEY = 'punchout_return_url';
export const PUNCHOUT_JWT_SESSION_ID_KEY = 'punchout_session_id';
// API path prefixes under APP_CONFIG.auth.apiRoot. This line talks to the v1 (wire-cut) services:
// cxml v1 takes single-string item ids (PunchoutCartItem.id) and shopping-cart v1 is what the cart
// client is pinned to.
export const CXML_API_PATH = '/cxml/v1';
export const SHOPPING_CART_API_PATH = '/shopping-cart/v1';

// Sentinel PromotionId used by the backend to tag the injected 5% punchout catalog
// promo price. Must stay in sync with the backend PunchoutPromo:PromotionId config.
export const PUNCHOUT_PROMO_ID = 'PUNCHOUT-PROMO-2026';
